module.exports={
	"Form": "PhysicalAssetDefectViewManifest",
	"Scope": "PhysicalAssetDefect-View",
	"Descriptors":
	{
		"PhysicalAssetDefectDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetDefect-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-Identity",
				"Group": "PhysicalAssetDefect-View-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetDefect-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-Identity",
				"Group": "PhysicalAssetDefect-View-Identity"
			}
		},
		"PhysicalAssetDefectDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetDefect-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAssetDefect-View-Details",
				"Group": "PhysicalAssetDefect-View-Details"
			}
		},
		"PhysicalAssetDefectDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "PhysicalAssetDefect-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetDefect-View-Details",
				"Group": "PhysicalAssetDefect-View-Details"
			}
		},
		"PhysicalAssetDefectDetails.PrimaryDocumentationURL":
		{
			"Name": "Primary Documentation URL",
			"Hash": "PhysicalAssetDefect-View-PrimaryDocumentationURL",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-Details",
				"Group": "PhysicalAssetDefect-View-Details"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS1":
		{
			"Name": "Good (CS1)",
			"Hash": "PhysicalAssetDefect-View-StateDescriptionCS1",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-ConditionStates",
				"Group": "PhysicalAssetDefect-View-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS2":
		{
			"Name": "Fair (CS2)",
			"Hash": "PhysicalAssetDefect-View-StateDescriptionCS2",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-ConditionStates",
				"Group": "PhysicalAssetDefect-View-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS3":
		{
			"Name": "Poor (CS3)",
			"Hash": "PhysicalAssetDefect-View-StateDescriptionCS3",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-ConditionStates",
				"Group": "PhysicalAssetDefect-View-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.StateDescriptions.CS4":
		{
			"Name": "Severe (CS4)",
			"Hash": "PhysicalAssetDefect-View-StateDescriptionCS4",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 6,
				"Section": "PhysicalAssetDefect-View-ConditionStates",
				"Group": "PhysicalAssetDefect-View-ConditionStates"
			}
		},
		"PhysicalAssetDefectDetails.IDPhysicalAssetDefect":
		{
			"Name": "IDPhysical Asset Defect",
			"Hash": "PhysicalAssetDefect-View-IDPhysicalAssetDefect",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.GUIDPhysicalAssetDefect":
		{
			"Name": "GUIDPhysical Asset Defect",
			"Hash": "PhysicalAssetDefect-View-GUIDPhysicalAssetDefect",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetDefect-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetDefect-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetDefect-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		},
		"PhysicalAssetDefectDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetDefect-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAssetDefect-View-DataAudit",
				"Group": "PhysicalAssetDefect-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetDefect-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetDefect-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetDefect-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetDefect-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Condition State Descriptions",
			"Hash": "PhysicalAssetDefect-View-ConditionStates",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Condition State Descriptions",
					"Hash": "PhysicalAssetDefect-View-ConditionStates",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetDefect-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetDefect-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
